import { useEffect } from 'react';

import {
  useCurrentInspectionTemplate,
  type UseCurrentInspectionTemplateResult,
} from 'react-hooks';

export type UseInspectionTemplateCustomizeRouteFetchResult = Pick<
  UseCurrentInspectionTemplateResult,
  | 'template'
  | 'baselineTemplate'
  | 'loading'
  | 'error'
  | 'called'
  | 'fetchCurrentInspectionTemplate'
>;

export function useInspectionTemplateCustomizeRouteFetch(
  channelId: string | undefined,
  templateId: string | undefined
): UseInspectionTemplateCustomizeRouteFetchResult {
  const {
    template,
    baselineTemplate,
    loading,
    error,
    called,
    fetchCurrentInspectionTemplate,
  } = useCurrentInspectionTemplate();

  useEffect(() => {
    if (!channelId || !templateId) {
      return;
    }

    fetchCurrentInspectionTemplate({
      id: templateId,
      channelId,
    }).catch(() => undefined);
  }, [channelId, templateId, fetchCurrentInspectionTemplate]);

  return {
    template,
    baselineTemplate,
    loading,
    error,
    called,
    fetchCurrentInspectionTemplate,
  };
}
